export default [

     {
          path: '/asset-value-level',
          name: 'assetValueLevel',
          component: () => import("@/views/Page/assetValueLevel/assetValueLevel.vue"),
           meta: {
               title: 'Asset Value Level',
          },
     }
];